import { SearchResultListItem } from '~components/search/SearchResultListItem';
import { LoadMoreTrigger } from '~modules/media-library/view/List/LoadMoreTrigger';

type SearchResultLIstProps = {
  resultList: SearchResultsItem[];
  numFound?: number;
  onLoadMore?: () => void;
};

export function SearchResultList({ numFound = 0, resultList, onLoadMore }: SearchResultLIstProps) {
  const hasMore = numFound > resultList.length;

  return (
    <div className="ebm--result-list my-4">
      <div className="ebm--list-items relative flex flex-col gap-6 mx-auto max-w-screen-xl">
        {resultList.map((data, i) => (
          <SearchResultListItem key={i} {...data} />
        ))}
      </div>
      {hasMore && <LoadMoreTrigger onLoadMore={onLoadMore} />}
    </div>
  );
}
